import type { ReactNode } from 'react'

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

export interface NotificationItemContentProps {
  title: string
  subtitle: string
  preview: string
  relativeTime: string
  fullDateTime: string
}

export const NotificationItemContent = ({
  title,
  subtitle,
  preview,
  relativeTime,
  fullDateTime,
}: NotificationItemContentProps): ReactNode => {
  return (
    <div className="flex-1 min-w-0 space-y-1 overflow-hidden">
      <div className="flex items-start gap-2">
        <div className="flex-1 min-w-0">
          <span className="text-sm font-medium line-clamp-1">{title}</span>
          {subtitle && (
            <span className="text-xs text-muted-foreground line-clamp-1 block">{subtitle}</span>
          )}
        </div>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="text-xs text-muted-foreground whitespace-nowrap flex-shrink-0">
              {relativeTime}
            </span>
          </TooltipTrigger>
          <TooltipContent side="left" sideOffset={4}>
            {fullDateTime}
          </TooltipContent>
        </Tooltip>
      </div>
      <p className="text-sm text-muted-foreground line-clamp-2 break-words">{preview}</p>
    </div>
  )
}

NotificationItemContent.displayName = 'NotificationItemContent'
